<template>
  <div class="install" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" title="设置" :showBack="true"></my-header>
    <div class="mine-info-item border-bottom-style">
      <div class="w2" style="line-height: 1.54rem">头像</div>
      <img v-if="customerUser.avatarUrl != null && customerUser.avatarUrl != ''" class="mine-info-avatar" :src="customerUser.avatarUrl">
      <img v-else="" class="mine-info-avatar" src="../../assets/icon/icon-defualt-avatar.png">
    </div>
    <div class="mine-info-item border-bottom-style" @click="modifyNickname()">
      <div class="w2">昵称</div>
      <div style="display: flex;font-size: 0.28rem;color: #878e99">
        <div style="margin-right: 0.4rem">{{nickname}}</div>
        <img src="../../assets/index/enter.png">
      </div>
    </div>
    <div class="mine-info-item border-bottom-style" @click="toPassword()">
      <div>修改密码</div>
      <img src="../../assets/index/enter.png">
    </div>
    <div class="logout" @click="logout">退出登录</div>

    <!--<div v-if="logoutModal" class="toast refuse-modal">-->
      <!--<div class="refuse-modal-title">退出登录确认</div>-->
      <!--<div class="refuse-modal-text">您确认要退出登录吗？</div>-->
      <!--<div class="confirm-footer" >-->
        <!--<div class="cancel-btn" @click = "cancelLogout">取消</div>-->
        <!--<div class="agree-btn" @click = "confirmLogout">退出登录</div>-->
      <!--</div>-->
    <!--</div>-->
    <div v-if="logoutModal" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelLogout()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您确认要退出登录吗？</div>
      <div class="agree-btn" @click="confirmLogout()">退出登录</div>
    </div>
    <div v-if="logoutModal" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import userService from '../../service/customer/UserService'

  export default {
    name: 'Install',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        logoutModal:false,
        customerUser:{},
        nickname:'',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCustomerUserInfo();
    },
    methods: {
      async getCustomerUserInfo(){
        let result=await userService.getUserInfo();
        if(result.code == '0'){
          this.customerUser = result.data;
          this.nickname = this.customerUser.nickname;
        }else {
          Toast('获取客户信息失败');
        }
      },
      logout() {
        this.logoutModal = true;
      },
      toPassword() {
        this.$router.push({name:'ForgetPassword', query: {type:'1'}});
      },
      confirmLogout(){
        session.logout();
        this.$router.push("/login");
      },
      cancelLogout(){
        this.logoutModal = false;
      },
      modifyNickname(){
        this.$router.push({name: 'ModifyNickname'});
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .install{
    height: 100vh;
    background: white;
    font-size: 0.32rem;
    color: #1b1e29;
  }
  .mine-info-item{
    display: flex;
    justify-content: space-between;
    width: 6.88rem;
    margin: 0 auto;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;

    .mine-info-avatar{
      width: 1.54rem;
      height: 1.54rem;
      border-radius: 1.54rem;
    }
    .info-input{
      background-color: #f3f8fc;
      text-align: right;
      margin-left: 0.3rem;
    }
    img{
      width: 0.19rem;
      height: 0.33rem;
    }
  }
  .logout{
    width: 6.94rem;
    height: 0.92rem;
    line-height: 0.92rem;
    border-radius: 0.44rem;
    margin: 4.5rem auto 0rem auto;
    font-size: 0.36rem;
    color: white;
    text-align: center;
    letter-spacing: 0.05rem;
    background-color: #ff7544;
  }
  .w2{
    letter-spacing:2em; /*如果需要y个字两端对齐，则为(x-y)/(y-1),这里是（4-2）/(2-1)=2em */
    margin-right:-2em; /*同上*/
  }
  .w3{
    letter-spacing:0.5em; /*如果需要y个字两端对齐，则为(x-y)/(y-1),这里是（4-3）/(3-1)=0.5em */
    margin-right:-0.5em; /*同上*/
  }
</style>
